<template>
  <el-drawer
    title="预览"
    :visible.sync="drawerVisible"
    direction="rtl"
    size="600px"
    custom-class="preview-drawer"
    @close="$emit('close')"
  >
    <div class="content">
      <el-scrollbar :native="false">
        <div class="detail-box" v-loading="loading">
          <div class="custom">
            <div class="custom-name">{{data.madeName}}</div>
            <div v-html="data.madeContent"></div>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </el-drawer>
</template>
<script>
import { getPersonalMade } from '@/api/goods';

export default {
  name: 'customPage',
  data() {
    return {
      data: {},
      shopList: [],
      drawerVisible: false,
      loading: false,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectId: {
      type: Number,
      required: true,
    },
  },
  watch: {
    visible(value) {
      this.drawerVisible = value;
    },
    selectId(value) {
      this.handleShow(value);
    },
  },
  methods: {
    getPersonalMade(id) {
      return getPersonalMade(id).then((res) => {
        if (res.success) {
          this.data = res.data;
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    async handleShow(id) {
      this.loading = true;
      await this.getPersonalMade(id).catch(() => {});
    },
  },
};
</script>
<style lang="stylus" scoped>
@import "~assets/css/h5.styl";
.content
  .custom
    color #fff
  .custom-name
    text-align center
    font-size 16px
    margin-bottom 10px
  >>>img
    width 100%!important
</style>
